import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
    idsClientes?: number[],
    idsChecklist?: number[],
    tipoVistoria?: number,
    entregue?: number,
    unidade?: string,
    localVistoria?: string,
    dataDe?: Date | null,
    dataAte?: Date | null,
};

type Action = {
    setIdsClientes: (idsClientes: number[]) => void,
    setIdsChecklist: (idsChecklist: number[]) => void,
    setTipoVistoria: (tipoVistoria: number) => void,
    setEntregue: (entregue: number) => void,
    setUnidade: (unidade: string) => void,
    setLocalVistoria: (localVistoria: string) => void,
    setDataDe: (dataDe: Date | null) => void,
    setDataAte: (dataAte: Date | null) => void,
    clearFilters: () => void
};

export const useEntregaObrasClienteListaFilters = create<State & Action>((set) => ({
    idsClientes: [],
    idsChecklist: [],
    tipoVistoria: undefined,
    entregue: undefined,
    unidade: undefined,
    localVistoria: undefined,
    dataDe: undefined,
    dataAte: undefined,
    setIdsClientes: (idsClientes: number[]) => set({ idsClientes }),
    setIdsChecklist: (idsChecklist: number[]) => set({ idsChecklist }),
    setTipoVistoria: (tipoVistoria: number) => set({ tipoVistoria }),
    setEntregue: (entregue: number) => set({ entregue }),
    setUnidade: (unidade: string) => set({ unidade }),
    setLocalVistoria: (localVistoria: string) => set({ localVistoria }),
    setDataDe: (dataDe: Date | null) => set({ dataDe }),
    setDataAte: (dataAte: Date | null) => set({ dataAte }),
    clearFilters: () => set({
        idsClientes: [],
        idsChecklist: [],
        tipoVistoria: undefined,
        entregue: undefined,
        unidade: undefined,
        localVistoria: undefined,
        dataDe: null,
        dataAte: null,
    }),
}));

export const initialEntregaObrasFiltersValues: State = {
    idsClientes: [],
    idsChecklist: [],
    tipoVistoria: undefined,
    entregue: undefined,
    unidade: undefined,
    localVistoria: undefined,
    dataDe: null,
    dataAte: null,

}